export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;

  return {
    width,
    height,
  };
};

export const sizeToSlice = (windowWidthDimensions: number) => {
  if (windowWidthDimensions >= 2426) return 8;
  if (windowWidthDimensions >= 1976) return 7;
  if (windowWidthDimensions >= 1800) return 6;
  if (windowWidthDimensions >= 1672) return 5;
  if (windowWidthDimensions >= 1300) return 4;
  if (windowWidthDimensions >= 1200) return 3;
  if (windowWidthDimensions >= 1024) return 2;
  if (windowWidthDimensions >= 768) return 1;
  if (windowWidthDimensions < 768) return 0;
};
